import { ROOT_KEY } from './root';

export const metaKeys = {
  all: [...ROOT_KEY, 'meta'] as const,
  detail: () => [...metaKeys.all, 'detail'] as const,
};
